var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { fontColor } from '../utils/theme';
var Subtitle = styled.h2(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 1rem;\n  font-weight: 900;\n  color: ", ";\n  margin: 0;\n  text-align: ", ";\n"], ["\n  font-size: 1rem;\n  font-weight: 900;\n  color: ", ";\n  margin: 0;\n  text-align: ", ";\n"])), function (props) { return fontColor(props); }, function (props) { return props.align; });
export default Subtitle;
var templateObject_1;
